import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { Authentication } from '@app/classes/Authentication';
import { SpaConfiguration } from '@configuration/SpaConfiguration';
import MainLoading from '../components/loadings/MainLoading';
import { set } from 'lodash';

export const Registration: React.FC = () => {
    const search = useLocation().search;
    const accessPrincipalId = new URLSearchParams(search).get('accessPrincipalId');
    const email = new URLSearchParams(search).get('email');
    const invitationId = new URLSearchParams(search).get('invitationId');

    const [hasError, setHasError] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        SpaConfiguration.loadAsync()
            .then(() => {
                return Authentication.loginRedirect({
                    "accessPrincipalId": accessPrincipalId,
                    "email": email,
                    "isCustomSignupFromEmail": "true",
                }, "/", null, SpaConfiguration.get().b2cSignupPolicy ? SpaConfiguration.get().authority + SpaConfiguration.get().b2cSignupPolicy : null, {
                    invitationId: invitationId,
                });
            })
            .catch(async (error) => {
                console.error("Error during registration redirect login:", error);
                setHasError(true);
                setError(error.toString());
                await Xrm.Navigation.openErrorDialog({ message: "An error occurred during registration. Please try again later.", details: error.toString() });
            });
    }, []);

    return (
        <div>
            {hasError ? (
                <div className="error-message">
                    <h2>Registration Error</h2>
                    <p>{error}</p>
                </div>
            ) : <MainLoading isLoading={true} />}
        </div>
    );
};